/*
 * Copyright © 2021-present Protonbase Inc. All rights reserved.
 * The information contained in this software is confidential and proprietary to Protonbase Inc. and its subsidiaries. No part of this software may be used, copied, reproduced, modified, displayed, performed, executed, published, distributed, conveyed, stored, transmitted, or otherwise exploited in any form or by any means, including but not limited to electronic, mechanical, photocopying, recording, transcribing, without the prior written consent of Protonbase Inc.
 * Any violation of the above terms will constitute an infringement of copyright and will be subjected to legal action.
 */
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Button, Space } from 'antd'
import { useParams, useNavigate } from 'react-router-dom'
import { PlatformList } from '@/components/PlatformList'
import { TPlatformListService } from '@/components/PlatformList/interface'
import { LayoutOthers } from '@/layouts/LayoutOthers'
import { useRoleUsersColumns } from '@/pages/auth/RoleUsers/useRoleUsersColumns'
import { GrantRoleToUser } from '@/pages/auth/features/GrantRoleToUser'
import { RoleDescription } from '@/pages/auth/features/RoleDescription'
import { TRoleName } from '@/pages/auth/interface'
import { accountClient } from '@/services/cloudClient/accountClient'

export function RoleUsers() {
  const { contractId, role } = useParams()
  const navigate = useNavigate()
  const columns = useRoleUsersColumns(role as TRoleName)
  const emitter = PlatformList.useCreateEmitter()

  const service: TPlatformListService = () => {
    return accountClient.contractsApi.listChildrenOfContractRole(contractId, role).then(res => {
      return {
        data: {
          items: res.data,
        },
      }
    })
  }

  return (
    <>
      <LayoutOthers.Alert className="margin-bottom-20">
        <RoleDescription roleName={role as TRoleName} />
      </LayoutOthers.Alert>
      <PlatformList
        emitter={emitter}
        service={service}
        createTitle={() => (
          <>
            <Space>
              <Button onClick={() => navigate(-1)} type="primary" icon={<ArrowLeftOutlined />} ghost />
              <strong>{role}</strong>
            </Space>
            <GrantRoleToUser role={role} type="primary" />
          </>
        )}
        columns={columns}
        rowKey={record => record.name}
        pagination={false}
        expandable={{ childrenColumnName: 'unknown' }}
      />
    </>
  )
}
